import React from 'react';
import { XIcon } from 'lucide-react';

export function ActiveFilters({ columnFilters, textFilters, meta, onRemoveValues, onRemoveText, onClearAll }) {
  // Filters on columns that no longer exist (e.g. from an older saved view) are ignored.
  const valueChips = Object.keys(columnFilters).filter(k => columnFilters[k]?.length && meta[k]);
  const textChips = Object.keys(textFilters).filter(k => textFilters[k] && meta[k]);
  if (!valueChips.length && !textChips.length) return null;

  const describe = values => (values.length <= 2 ? values.join(', ') : `${values[0]} +${values.length - 1}`);

  return (
    <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-border-b tw-border-neutral-200 tw-px-5 tw-py-2.5">
      {valueChips.map(k => (
        <Chip key={`v-${k}`} label={meta[k].label} value={describe(columnFilters[k] ?? [])} onRemove={() => onRemoveValues(k)} />
      ))}
      {textChips.map(k => (
        <Chip key={`t-${k}`} label={meta[k].label} value={`contains “${textFilters[k]}”`} onRemove={() => onRemoveText(k)} />
      ))}
      <button type="button" onClick={onClearAll} className="tw-ml-1 tw-text-sm tw-font-medium tw-text-neutral-500 tw-transition-colors hover:tw-text-neutral-900">
        Clear all
      </button>
    </div>
  );
}

function Chip({ label, value, onRemove }) {
  return (
    <span className="tw-inline-flex tw-items-center tw-gap-1 tw-rounded-full tw-border tw-border-brand-200 tw-bg-brand-50 tw-py-0.5 tw-pl-2.5 tw-pr-1 tw-text-xs tw-text-brand-600">
      <span className="tw-max-w-[200px] tw-truncate tw-font-medium">{label}:</span>
      <span className="tw-max-w-[200px] tw-truncate">{value}</span>
      <button type="button" onClick={onRemove} aria-label={`Remove ${label} filter`} className="tw-rounded-full tw-p-0.5 tw-transition-colors hover:tw-bg-brand-100">
        <XIcon className="tw-h-3 tw-w-3" />
      </button>
    </span>
  );
}
